import React from 'react'
import { Form } from "react-bootstrap"
import { DefaultButton } from '@fluentui/react/lib/Button';



function CLabel(props) {

    //Parametros de entrada.
    const inputParam_Black = props.black !== null && props.black !== undefined ? props.black : true;
    const inputParam_LabelText = props.labelText !== null && props.labelText !== undefined ? props.labelText : "";
    const inputParam_LabelValue = props.labelValue !== null && props.labelValue !== undefined ? props.labelValue : "";
    const inputParam_Linked = props.linked !== null && props.linked !== undefined ? props.linked : false;
    const inputParam_LinkedWithIcon = props.linkedWithIcon !== null && props.linkedWithIcon !== undefined ? props.linkedWithIcon : false;
    const inputParam_LinkedIconProps = props.linkedIconProps !== null && props.linkedIconProps !== undefined ? props.linkedIconProps : "";
    const inputParam_LinkedEventFire = props.linkedEventFire !== null && props.linkedEventFire !== undefined ? props.linkedEventFire : null;
    const inputParam_LinkedEventParam = props.linkedEventParam !== null && props.linkedEventParam !== undefined ? props.linkedEventParam : null;
    const inputParam_AditionalStyles = props.aditionalStyles !== null && props.aditionalStyles !== undefined ? props.aditionalStyles : null;
    const inputParam_LinkMinWidth = props.linkMinWidth !== null && props.linkMinWidth !== undefined ? props.linkMinWidth : null;
    const inputParam_ClassName = props.className !== null && props.className !== undefined ? props.className : "";
    const inputParam_AddBreak = props.addBreak !== null && props.addBreak !== undefined ? props.addBreak : null;
    
    
    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <>
            {
                inputParam_Linked &&
                <>
                    {
                        inputParam_LinkedWithIcon &&
                        <>
                            <b><Form.Label style={inputParam_AditionalStyles} className={"pe-2 " + inputParam_ClassName}>{ inputParam_LabelText }:</Form.Label></b>
                            {
                                inputParam_LabelValue &&
                                <DefaultButton
                                    menuIconProps={inputParam_LinkedIconProps}
                                    className={inputParam_ClassName}
                                    onClick={ () => inputParam_LinkedEventFire(inputParam_LinkedEventParam) }
                                    styles={
                                        {
                                            root: {border: "none", fontWeight: "normal"},
                                            rootHovered: { backgroundColor: "#fff", color: "rgb(0, 120, 212)" },
                                            menuIcon: { fontSize: "16px", marginBottom: "30px" },
                                            label: { fontWeight: "normal" }
                                        }
                                    }
                                >
                                    { inputParam_LabelValue }
                                </DefaultButton>
                            }
                        </>
                    }
                    {
                        !inputParam_LinkedWithIcon &&
                        <>
                            <b><Form.Label style={inputParam_AditionalStyles} className={"pe-2 " + inputParam_ClassName}>{ inputParam_LabelText }:</Form.Label></b>
                            {
                                inputParam_LabelValue &&
                                <DefaultButton
                                    menuIconProps={null}
                                    className={inputParam_ClassName}
                                    onClick={ () => inputParam_LinkedEventFire(inputParam_LinkedEventParam) }
                                    styles={
                                        {
                                            root: {border: "none", fontWeight: "normal", minWidth: (inputParam_LinkMinWidth !== null ? inputParam_LinkMinWidth : "")},
                                            rootHovered: { backgroundColor: "#fff", color: "rgb(0, 120, 212)" },
                                            menuIcon: { fontSize: "16px", marginBottom: "30px" },
                                            label: { fontWeight: "normal" }
                                        }
                                    }
                                >
                                    { inputParam_LabelValue }
                                </DefaultButton>
                            }
                        </>
                    }
                </>
            }
            {
                !inputParam_Linked &&
                <>
                    {
                        inputParam_LabelText && inputParam_LabelText !== "" &&
                            <>
                                {
                                    inputParam_Black === true &&
                                    <b><Form.Label style={inputParam_AditionalStyles} className={"pe-2 " + inputParam_ClassName}>{ inputParam_LabelText }: </Form.Label></b>
                                }
                                {
                                    inputParam_Black === false &&
                                    <Form.Label style={inputParam_AditionalStyles} className={"pe-2 " + inputParam_ClassName}>{ inputParam_LabelText }: </Form.Label>
                                }
                            </>
                    }
                    {
                        !inputParam_AddBreak &&
                        <Form.Label className={"pe-2 " + inputParam_ClassName} style={inputParam_AditionalStyles}>{ inputParam_LabelValue }</Form.Label>
                    }
                    {
                        inputParam_AddBreak &&
                        <>
                            <br/>
                            <Form.Label className={"pe-2 " + inputParam_ClassName} style={inputParam_AditionalStyles}>{ inputParam_LabelValue }</Form.Label>
                        </>
                    }
                </>
            }
        </>
    );
}

export default CLabel;